import classNames from 'classnames';
import '../styles/SlidePanelHeadline.scss';

function SlidePanelHeadline({ children, id, theme }) {
    const dynamicAttributes = {};

    if (id) {
        dynamicAttributes.id = id;
    }

    return (
        <div
            className={classNames('slide-panel-headline', {
                [`slide-panel-headline--${theme}`]: typeof theme !== 'undefined'
            })}
            {...dynamicAttributes}
        >
            {children}
        </div>
    );
}

export default SlidePanelHeadline;
